var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getThemeClass(),attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('TurnBlack')],1)}
var staticRenderFns = []

export { render, staticRenderFns }